import GenericShowPage from "../components/events/GenericShowPage";

export default function ShowPage () {

    return (
        <>
        <GenericShowPage/>
        </>
    )
}